import React from "react";
import "./styles.css";
import { useNavigate } from "react-router";
import { viewSponsoredStudy } from "@/utils/analytics/googleAnalytics";
// Make sure to import useNavigate
interface CardProps {
    imageLink: string;
    title: string;
    nctId: string;
}

function CardsComponent(props: CardProps) {
    const { imageLink, title, nctId } = props;
    const navigate = useNavigate(); // Get the navigate function

    const handleClick = () => {
        viewSponsoredStudy(nctId);
        navigate(`/study/${nctId}`); // Navigate when the card is clicked
    };

    const handleKeyPress = (event: React.KeyboardEvent<HTMLDivElement>) => {
        if (event.key === "Enter" || event.key === " ") {
            // Check for Enter or Space
            event.preventDefault(); // Prevent default behavior for space
            handleClick(); // Call the click handler
        }
    };

    return (
        <div
            className="sponsor-card"
            onClick={handleClick}
            onKeyDown={handleKeyPress}
            role="button" // Set the role
            tabIndex={0} // Make the div focusable
            style={{ cursor: "pointer" }}
        >
            <img className="sponsor-card-icon" src={imageLink} alt="Icon" />
            <div className="sponsor-card-content">
                <div className="sponsor-card-title">{title}</div>
            </div>
        </div>
    );
}

export default CardsComponent;
